export default function CalculateRequiredIncomeToAfford(
    homeValue,
    monthlyExpenses,
    interestRatePercent,
    hiSpendPercent = .30,
    downPaymentPercent = .20
) {
    const numberOfPayments = 360; // 30 years * 12 months
    const interestRate = (interestRatePercent) / 12;
    const loanAmount = homeValue * (1 - (downPaymentPercent));

    // Monthly mortgage payment calculation (P&I)
    const monthlyMortgage = loanAmount *
        (interestRate * Math.pow(1 + interestRate, numberOfPayments)) /
        (Math.pow(1 + interestRate, numberOfPayments) - 1);

    // Total monthly housing cost
    const totalMonthlyPayment = monthlyMortgage + monthlyExpenses;

    // console.log('ImpactOnValue calculation:', {
    //     homeValue,
    //     monthlyExpenses,
    //     interestRatePercent,
    //     loanAmount,
    //     monthlyMortgage,
    //     totalMonthlyPayment,
    //     hiSpendPercent,
    //     result: (totalMonthlyPayment * 12) / (hiSpendPercent / 100)
    // });

    // Return annual income required (remove the /100 since hiSpendPercent is already in decimal form)
    return (totalMonthlyPayment * 12) / hiSpendPercent;
}